/* eslint-disable */
import type { FC } from 'react';
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Link,
  TextField,
  Typography,
} from '@material-ui/core';
import LogoNavBar from './LogoNavBar';
import { createTheme } from 'src/theme';
import { useNavigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { useSnackbar } from 'notistack';

const sections = [
  {
    title: 'Acerca de nosotros',
    links: [
      {
        title: '¿Qué hacemos?',
        href: '/#what',
      },
      {
        title: 'Así funcionamos',
        href: '/#video',
      },
      {
        title: '¿Cómo lo hacemos?',
        href: '/#how',
      },
      {
        title: 'Nuestras ventajas competitivas',
        href: '/#advantage',
      },
      {
        title: '¿Por qué elegir a Release®?',
        href: '/#benefit',
      },
      {
        title: 'Proveedores',
        href: '/proveedor/',
      },
    ],
  },
  {
    title: 'Legales',
    links: [
      {
        title: 'Términos y condiciones',
        href: '/condiciones',
      },
      {
        title: 'Política de privacidad',
        href: '/politicas',
      },
    ],
  },
  {
    title: 'Ayuda y contacto',
    links: [
      {
        title: 'support@releasefintech.com',
        href: 'mailto:support@releasefintech.com',
      },
      {
        title: 'info@releasefintech.com',
        href: 'mailto:info@releasefintech.com',
      },
      {
        title: 'Preguntas frecuentes',
        href: '/faq',
      },
      {
        title: 'Proceso de Incorporación a Release®',
        href: '/comenzar',
      },
    ],
  },
];

const theme = createTheme({});

const Footer: FC = (props) => {
  let history = createBrowserHistory();
  const { enqueueSnackbar } = useSnackbar();

  return (
    <>
      <Box
        display={'flex'}
        justifyContent={'center'}
        width={'100%'}
        position={'relative'}
        top={'40px'}
        zIndex={'998'}
      >
        <Box sx={{ width: '229px', height: '76px' }}>
          <Card
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <LogoNavBar
              sx={{
                pl: 3,
                height: 40,
                width: 210,
              }}
            />
          </Card>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: 'background.default',
          pb: 6,
          pt: {
            md: 15,
            xs: 6,
          },
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={3}
            sx={{
              [theme.breakpoints.down('sm')]: {
                paddingTop: '40px',
              },
            }}
          >
            {sections.map((section, index) => (
              <Grid
                item
                key={section.title + index}
                md={3}
                sm={4}
                xs={12}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'flex-start'}
              >
                <Typography
                  sx={{ color: '#4a5b6d' }}
                  fontSize={'18px'}
                  fontWeight={700}
                  pl={1}
                >
                  {section.title}
                </Typography>
                {section.links.map((link, i) => {
                  // return link.title !== 'Proveedores' ? (
                  return (
                    <Button key={`btnfooter` + i} href={link.href}>
                      <Typography pt={1} pb={1}>
                        {link.title}
                      </Typography>
                    </Button>
                  );
                })}
              </Grid>
            ))}
            <Grid
              item
              md={3}
              sm={4}
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
              xs={12}
            >
              <Typography
                sx={{ color: '#4a5b6d' }}
                fontSize={'18px'}
                fontWeight={700}
                pl={1}
                pb={2}
              >
                Sé el primero en enterarte del lanzamiento de Release
                <span style={{ fontSize: '13px', verticalAlign: 'top' }}>
                  ®
                </span>{' '}
              </Typography>
              <form
                onSubmit={(event) => {
                  event.preventDefault();
                  enqueueSnackbar('¡Tu suscripción se realizó con éxito!', {
                    anchorOrigin: {
                      horizontal: 'right',
                      vertical: 'top',
                    },
                    variant: 'success',
                  });
                }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} sx={{ ml: 1, mr: 2 }}>
                    <TextField
                      fullWidth
                      label="Correo"
                      name="correo"
                      required
                      variant="outlined"
                      sx={{
                        backgroundColor: 'white',
                        borderRadius: '16px',
                      }}
                    />
                  </Grid>
                </Grid>
                <Box sx={{ mt: 2, pl: 1 }}>
                  <Button
                    sx={{
                      backgroundColor: '#FCBE00',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: '#fbd972',
                      },
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Suscribirme
                  </Button>
                </Box>
              </form>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          backgroundColor: '#001930',
          height: '34px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography sx={{ color: 'white' }} variant="caption">
          ®Release 2022. Todos los derechos reservados
        </Typography>
      </Box>
    </>
  );
};

export default Footer;
